import { createApp } from 'vue'
// import {  } from '@vuelidate/core'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import '@/scss/index.scss'
import axios from 'axios'
import VueAxios from 'vue-axios'

createApp(App)
  .use(router, VueAxios, axios)
  // .use(VuelidatePlugin)
  .mount('#app')
